import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { BehaviorSubject, Observable, asapScheduler } from 'rxjs'
import { distinctUntilChanged, observeOn } from 'rxjs/operators'
import { Crumb, RecordCrumbs, pathOf } from './breadcrumbs.util'

export interface PublishedRecord extends RecordCrumbs {
  /** The page it was published from, so the next page never shows the last one's name. */
  path: string
}

/**
 * The record a page has open, for the breadcrumb trail. The route only knows "Opening" or
 * "Candidate Detail"; the record loads after it, so the page publishes its name here once it has
 * loaded — and only then, since the trail stays empty until it arrives — and clears it on the way out.
 *
 * `observeOn(asapScheduler)` for the same reason as {@link PageTitleService}: `set()` runs after the
 * header has been checked, so a synchronous emission throws NG0100.
 */
@Injectable({ providedIn: 'root' })
export class RecordTitleService {
  private readonly source = new BehaviorSubject<PublishedRecord | null>(null)
  readonly record$: Observable<PublishedRecord | null> = this.source.pipe(
    distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
    observeOn(asapScheduler)
  )

  constructor(private router: Router) {}

  set(title: string | null | undefined, back?: Crumb): void {
    this.source.next({ path: pathOf(this.router.url), title: title?.trim() || null, back })
  }

  clear(): void {
    this.source.next(null)
  }
}
